module.exports = __webpack_public_path__ + "img/triangle-50.409ebefe.gif";